import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from './store'; // 添加这行
import ToastPlugin from './utils/toast';
Vue.use(ToastPlugin);
//全局挂载axios
Vue.prototype.$axios = axios
Vue.config.productionTip = false

new Vue({
  router,
  store, // 添加这行
  render: function (h) { return h(App) }
}).$mount('#app')


// 在main.js末尾添加
Vue.prototype.$TGDialogS = function(elmId) {
  TGDialogS(elmId);
};

Vue.prototype.$closeDialog = function() {
  closeDialog();
};

Vue.prototype.$copyText = function(text) {
  return new Promise((resolve, reject) => {
    if (!text) {
      // reject(new Error('复制内容不能为空'));
      console.log('复制内容不能为空');
      return;
    }

    // 创建临时文本区域
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      // 传统方法（兼容性好）
      const successful = document.execCommand('copy');
      if (successful) {
        resolve('复制成功');
      } else {
        // 现代浏览器Clipboard API
        if (navigator.clipboard) {
          navigator.clipboard.writeText(text).then(() => {
            resolve('复制成功');
          }).catch(err => {
            reject(new Error('复制失败: ' + err.message));
          });
        } else {
          reject(new Error('浏览器不支持复制功能'));
        }
      }
    } catch (err) {
      reject(new Error('复制失败: ' + err.message));
    } finally {
      document.body.removeChild(textarea);
    }
  });
};

// 全局挂载节流点击方法，默认延迟1000ms(1秒)
Vue.prototype.$throttleClick = function (callback, delay = 1000) {
  // 标记是否可点击
  let canClick = true
  return async (...args) => {
    // 不可点击时直接返回
    if (!canClick) return
    // 锁定点击状态
    canClick = false
    try {
      // 执行传入的业务方法
      await callback.apply(this, args)
    } catch (err) {
      console.error('节流方法执行异常：', err)
    } finally {
      // 延迟后解锁
      setTimeout(() => {
        canClick = true
      }, delay)
    }
  }
}